import script from "./systemMsg.vue?vue&type=script&setup=true&name=SystemMsg&lang=js"
export * from "./systemMsg.vue?vue&type=script&setup=true&name=SystemMsg&lang=js"

import "./systemMsg.vue?vue&type=style&index=0&id=438972bc&scoped=true&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-438972bc"]])

export default __exports__